/* eslint-disable no-console */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { Button, DescriptionTable } from 'shared/components';
import { displayValue, hasPermission } from 'shared/helpers';
import CustomerForm from 'customer/CustomerForm';

const CustomerDetails = ({ order, customer, refetchOrder }) => {
  const { t } = useTranslation();
  const customerData = customer || get(order, 'customer', {});

  const hasEditPermission = hasPermission('edit_customer');

  const [showCustomerForm, setShowCustomerForm] = useState(false);

  return (
    <div className="CustomerDetails CustomerContainer">
      <div className="CustomerDetails-header">
        {hasEditPermission && customerData && (
          <Button
            onClick={() => setShowCustomerForm(true)}
            theme="info"
            size="sm"
          >
            {t('Edit customer')}
          </Button>
        )}
      </div>
      <DescriptionTable
        details={[
          {
            label: t('Email'),
            value: displayValue(get(customerData, 'email')),
          },
          {
            label: t('First Name'),
            value: displayValue(get(customerData, 'first_name')),
          },
          {
            label: t('Last Name'),
            value: displayValue(get(customerData, 'last_name')),
          },
          {
            label: t('Address'),
            value: displayValue(get(customerData, 'address')),
          },
          { label: t('City'), value: displayValue(get(customerData, 'city')) },
          {
            label: t('State / Province'),
            value: displayValue(get(customerData, 'state')),
          },
          {
            label: t('Country'),
            value: displayValue(get(customerData, 'country')),
          },
          {
            label: t('Zipcode / Postcode'),
            value: displayValue(get(customerData, 'postcode')),
          },
          {
            label: t('Phone number'),
            value: displayValue(get(customerData, 'phone')),
          },
          {
            label: t('Company'),
            value: displayValue(get(customerData, 'company_name')),
          },
          {
            label: t('Reference'),
            value: displayValue(get(customerData, 'reference')),
          },
        ]}
      />
      {hasEditPermission && showCustomerForm && (
        <CustomerForm
          closeForm={() => setShowCustomerForm(false)}
          customer={customerData}
          updateCustomer={refetchOrder}
        />
      )}
    </div>
  );
};

CustomerDetails.propTypes = {
  order: PropTypes.object.isRequired,
  customer: PropTypes.object,
  refetchOrder: PropTypes.func.isRequired,
};

CustomerDetails.defaultProps = {
  customer: null,
};

export default CustomerDetails;
